const AltFacebookIcon = ({ color }: any) => {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M15.0007 1.66797H12.5007C11.3956 1.66797 10.3358 2.10696 9.55437 2.88836C8.77297 3.66976 8.33398 4.72957 8.33398 5.83464V8.33464H5.83398V11.668H8.33398V18.3346H11.6673V11.668H14.1673L15.0007 8.33464H11.6673V5.83464C11.6673 5.61362 11.7551 5.40166 11.9114 5.24538C12.0677 5.0891 12.2796 5.0013 12.5007 5.0013H15.0007V1.66797Z'
        fill='white'
      />
    </svg>
  )
}

export default AltFacebookIcon
